import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  DosatorSetting,
  GetDosatorSettingsResponse,
  UpsertDosatorSettingResponse,
} from '../models/settings.model';

@Injectable({
  providedIn: 'root',
})
export class DosatorSettingService {
  private baseUrl = `${this.env.API_BASE_URL}/service/pig-registration/secure/dosator-setting`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  upsertDosatorSetting(dosatorSetting: DosatorSetting): Observable<UpsertDosatorSettingResponse> {
    return this.http.post<UpsertDosatorSettingResponse>(this.baseUrl, dosatorSetting, {});
  }

  deleteDosatorSetting(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  getDosatorSettings(): Observable<DosatorSetting[] | HttpErrorResponse> {
    return this.http.get<GetDosatorSettingsResponse>(this.baseUrl).pipe(
      map((response: GetDosatorSettingsResponse) => response.dosatorSettings),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<DosatorSetting[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
